//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    data: function data() {
        return {
            unitData: {},
            unitStats: [],
            unit: '',
            loading: true,
            unitResident: null,
            editLeases: false
        };
    },

    computed: {
        canEditLease: function canEditLease() {
            return window.user.can['update-all'] || window.user.can['update-lease'];
        },
        numberOfBedrooms: function numberOfBedrooms() {

            return this.unitData.bedrooms > 0 ? this.unitData.bedrooms + ' Bed' : 'Studio';
        }
    },
    watch: {
        unit: function unit(newVal, oldVal) {
            if (newVal) {
                this.unitData = [];
                this.unitStats = [];
                this.unit = newVal;
                this.refreshData();
            }
        }
    },
    mounted: function mounted() {
        var _this = this;

        var $el = this;

        Event.$on('view-unit', function (unit) {
            $el.$children[0].$data.showModal = true;
            $el.unit = unit;
            $el.loading = true;
            _this.refreshData();

            //Event.$emit('show-full-modal','Unit Details','22','view-building')
        });

        Event.$on('view-unit-refresh', function (unit) {
            $el.unit = unit;
            _this.refreshData();
        });
    },

    methods: {
        editLeaseData: function editLeaseData() {
            var $el = this;
            this.editLeases = true;
            // console.log('editLeaseData');
        },
        saveLeaseData: function saveLeaseData() {
            var _this2 = this;

            var $el = this;
            // console.log('saveLeaseData');
            axios.post('/prototype/unit/lease-data', { unit: $el.unitData }).then(function (response) {
                // console.log(response.data);
                if (response.data.error) {
                    _this2.$snotify.error('Error saving lease data: ' + response.data.error);
                } else {
                    _this2.$snotify.success('Lease data was updated');
                    _this2.editLeases = false;
                    _this2.refreshData();
                }
            });
        },
        ordinal: function ordinal(number) {

            if (number % 1 != 0) {
                //in case it's 2.5 or something
                return number;
            }

            var ends = ['th', 'st', 'nd', 'rd', 'th', 'th', 'th', 'th', 'th', 'th'];
            if (number % 100 >= 11 && number % 100 <= 13) {
                return number + 'th';
            } else {
                return number + ends[number % 10];
            }
        },
        refreshData: function refreshData() {
            var $el = this;
            if ($el.unit) {
                axios.get('/prototype/units/' + $el.unit).then(function (response) {
                    if (response.data) {
                        $el.unitData = response.data;
                        $el.loading = false;
                        $el.unitResident = $el.unitData.residents[0];
                        Event.$emit('load-unit-summary', $el.unitData);
                    }
                });
            }
        },
        addNewGuest: function addNewGuest() {
            var $el = this;
            Event.$emit('add-new-guest', $el.unit);
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"cacheDirectory":true,"presets":[["env",{"modules":false,"targets":{"browsers":["> 2%"],"uglify":true}}]],"plugins":["transform-object-rest-spread",["transform-runtime",{"polyfill":false,"helpers":false}]],"env":{"test":{"presets":[["env",{"targets":{"node":"current"}}]]},"development":{"presets":[["env",{"modules":false}]]},"production":{"presets":[["env",{"modules":false,"targets":{"browsers":"> 2%","uglify":true}}]]}}}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/unit/UnitDetails.vue
// module id = NMle
// module chunks = 0 1